import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { ExpandingFAQ, FrequentlyAskedQuestionsContainer } from './FrequentlyAskedQuestions';
import { getAcademyUrlPublic, getAppMarketplaceUrl, getCMSUrlPublic, getCommunityUrlPublic, getDevelopersAndApiDocsBaseUrl, getDevelopersApiDocsUrl, getDevelopersQuickStartGuideUrl, getKBEmbedCTAUrlPublic, getKBImportToolUrlPublic, getKBMembershipsUrlPublic, getKBShareFormsUrlPublic, getKBTrackingCodeUrlPublic, getKnowledgeBaseUrlPublic, getLanguagesUrlPublic, getMembershipsExamplesUrl, getMicrositesExamplesUrl, getNonProfitsUrlPublic, getSecurityAndComplianceUrl, getSolutionsMarketplaceUrl, getStartupsUrlPublic, getTemplatesMarketplaceUrl, getWebsiteMigrationUrlPublic } from './FrequentlyAskedQuestionsPublicPageUrls';
import { handleClickFrequentlyAskedQuestionLink } from './trackFrequentlyAskedQuestions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const communityHref = getCommunityUrlPublic();
const langHref = getLanguagesUrlPublic();
const academyHref = getAcademyUrlPublic();
const kbHref = getKnowledgeBaseUrlPublic();
const cmsHref = getCMSUrlPublic();
const startupsHref = getStartupsUrlPublic('pricing-contentpage');
const nonprofitsHref = getNonProfitsUrlPublic('pricing-contentpage');
const shareFormsHref = getKBShareFormsUrlPublic();
const embedCTAHref = getKBEmbedCTAUrlPublic();
const trackingCodeHref = getKBTrackingCodeUrlPublic();
const micrositesExamplesHref = getMicrositesExamplesUrl();
const membershipsHref = getKBMembershipsUrlPublic();
const membershipsExamplesHref = getMembershipsExamplesUrl();
const quickStartHref = getDevelopersQuickStartGuideUrl();
const apiHref = getDevelopersAndApiDocsBaseUrl();
const hostingAndSecurityHref = getSecurityAndComplianceUrl();
const templatesHref = getTemplatesMarketplaceUrl();
const importToolHref = getKBImportToolUrlPublic();
const apiDocsHref = getDevelopersApiDocsUrl();
const solutionsPartnerHref = getSolutionsMarketplaceUrl();
const websiteMigrationHref = getWebsiteMigrationUrlPublic();
const appMarketPlaceHref = getAppMarketplaceUrl();
export const ContentHubFaqs = () => {
  return /*#__PURE__*/_jsxs(FrequentlyAskedQuestionsContainer, {
    children: [/*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.whatIsContentHub.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.whatIsContentHub.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          learnMoreLink: /*#__PURE__*/_jsx(Link, {
            href: cmsHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'content.whatIsContentHub',
                url: cmsHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.whatIsContentHub.learnMore"
            })
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          list: /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.listItem1"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.listItem2"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.listItem3"
              })
            })]
          }),
          appMarketPlaceLink: /*#__PURE__*/_jsx(Link, {
            href: appMarketPlaceHref,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'content.existingWebsite',
                url: appMarketPlaceHref,
                trackingSource: 'faq'
              });
            },
            external: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.appMarketplace"
            })
          }),
          formsLink: /*#__PURE__*/_jsx(Link, {
            href: shareFormsHref,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'content.existingWebsite',
                url: shareFormsHref,
                trackingSource: 'faq'
              });
            },
            external: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.forms"
            })
          }),
          ctasLink: /*#__PURE__*/_jsx(Link, {
            href: embedCTAHref,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'content.existingWebsite',
                url: embedCTAHref,
                trackingSource: 'faq'
              });
            },
            external: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.ctas"
            })
          }),
          trackingLink: /*#__PURE__*/_jsx(Link, {
            href: trackingCodeHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'content.existingWebsite',
                url: trackingCodeHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.tracking"
            })
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.micrositeCustomPortal.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.micrositeCustomPortal.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          websiteBuilderLink: /*#__PURE__*/_jsx(Link, {
            href: cmsHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'content.micrositeCustomPortal',
                url: cmsHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.micrositeCustomPortal.websiteBuilder"
            })
          }),
          micrositesExamplesLink: /*#__PURE__*/_jsx(Link, {
            href: micrositesExamplesHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'content.micrositeCustomPortal',
                url: micrositesExamplesHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.micrositeCustomPortal.here"
            })
          }),
          membershipsLink: /*#__PURE__*/_jsx(Link, {
            href: membershipsHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'content.micrositeCustomPortal',
                url: membershipsHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.micrositeCustomPortal.memberships"
            })
          }),
          membershipsExamplesLink: /*#__PURE__*/_jsx(Link, {
            href: membershipsExamplesHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'content.micrositeCustomPortal',
                url: membershipsExamplesHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.micrositeCustomPortal.here"
            })
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.trainDevelopersAndIT.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.trainDevelopersAndIT.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          list: /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                href: quickStartHref,
                onClick: function () {
                  handleClickFrequentlyAskedQuestionLink({
                    value: 'content.micrositeCustomPortal',
                    url: quickStartHref,
                    trackingSource: 'faq'
                  });
                },
                external: true,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "pricing-page-components.frequentlyAskedQuestions.content.trainDevelopersAndIT.listItem1"
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                href: apiHref,
                onClick: function () {
                  handleClickFrequentlyAskedQuestionLink({
                    value: 'content.micrositeCustomPortal',
                    url: apiHref,
                    trackingSource: 'faq'
                  });
                },
                external: true,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "pricing-page-components.frequentlyAskedQuestions.content.trainDevelopersAndIT.listItem2"
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                href: hostingAndSecurityHref,
                onClick: function () {
                  handleClickFrequentlyAskedQuestionLink({
                    value: 'content.micrositeCustomPortal',
                    url: hostingAndSecurityHref,
                    trackingSource: 'faq'
                  });
                },
                external: true,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "pricing-page-components.frequentlyAskedQuestions.content.trainDevelopersAndIT.listItem3"
                })
              })
            })]
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          list: /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.listItem1",
                options: {
                  templatesLink: /*#__PURE__*/_jsx(Link, {
                    href: templatesHref,
                    external: true,
                    onClick: function () {
                      handleClickFrequentlyAskedQuestionLink({
                        value: 'content.migrateExistingWebsite',
                        url: templatesHref,
                        trackingSource: 'faq'
                      });
                    },
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.templateMarketplace"
                    })
                  }),
                  importToolLink: /*#__PURE__*/_jsx(Link, {
                    href: importToolHref,
                    external: true,
                    onClick: function () {
                      handleClickFrequentlyAskedQuestionLink({
                        value: 'content.migrateExistingWebsite',
                        url: importToolHref,
                        trackingSource: 'faq'
                      });
                    },
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.importTools"
                    })
                  }),
                  quickStartLink: /*#__PURE__*/_jsx(Link, {
                    href: quickStartHref,
                    external: true,
                    onClick: function () {
                      handleClickFrequentlyAskedQuestionLink({
                        value: 'content.migrateExistingWebsite',
                        url: quickStartHref,
                        trackingSource: 'faq'
                      });
                    },
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.developerQuickStart"
                    })
                  })
                }
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.listItem2",
                options: {
                  quickStartLink: /*#__PURE__*/_jsx(Link, {
                    href: quickStartHref,
                    external: true,
                    onClick: function () {
                      handleClickFrequentlyAskedQuestionLink({
                        value: 'content.migrateExistingWebsite',
                        url: quickStartHref,
                        trackingSource: 'faq'
                      });
                    },
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.developerQuickStart"
                    })
                  }),
                  apiDocsLink: /*#__PURE__*/_jsx(Link, {
                    href: apiDocsHref,
                    external: true,
                    onClick: function () {
                      handleClickFrequentlyAskedQuestionLink({
                        value: 'content.migrateExistingWebsite',
                        url: apiDocsHref,
                        trackingSource: 'faq'
                      });
                    },
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.apis"
                    })
                  })
                }
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.listItem3",
                options: {
                  solutionsPartnerLink: /*#__PURE__*/_jsx(Link, {
                    href: solutionsPartnerHref,
                    external: true,
                    onClick: function () {
                      handleClickFrequentlyAskedQuestionLink({
                        value: 'content.migrateExistingWebsite',
                        url: solutionsPartnerHref,
                        trackingSource: 'faq'
                      });
                    },
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.solutionsPartner"
                    })
                  })
                }
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.listItem4",
                options: {
                  websiteMigrationLink: /*#__PURE__*/_jsx(Link, {
                    href: websiteMigrationHref,
                    external: true,
                    onClick: function () {
                      handleClickFrequentlyAskedQuestionLink({
                        value: 'content.migrateExistingWebsite',
                        url: websiteMigrationHref,
                        trackingSource: 'faq'
                      });
                    },
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.websiteMigrationService"
                    })
                  })
                }
              })
            })]
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.whatSupport.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.whatSupport.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          langLink: /*#__PURE__*/_jsx(Link, {
            href: langHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'content.whatSupport',
                url: langHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.whatSupport.languageOfferings"
            })
          }),
          communityLink: /*#__PURE__*/_jsx(Link, {
            href: communityHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'content.whatSupport',
                url: communityHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.whatSupport.hubSpotCommunity"
            })
          }),
          academyLink: /*#__PURE__*/_jsx(Link, {
            href: academyHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'content.whatSupport',
                url: academyHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.whatSupport.hubSpotAcademy"
            })
          }),
          kbLink: /*#__PURE__*/_jsx(Link, {
            href: kbHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'content.whatSupport',
                url: kbHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.whatSupport.knowledgeBase"
            })
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.whatDiscounts.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.whatDiscounts.answer",
        options: {
          startupsLink: /*#__PURE__*/_jsx(Link, {
            href: startupsHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'content.whatDiscounts',
                url: startupsHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.whatDiscounts.hubSpotStartupsProgram"
            })
          }),
          nonprofitsLink: /*#__PURE__*/_jsx(Link, {
            href: nonprofitsHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'content.whatDiscounts',
                url: nonprofitsHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.whatDiscounts.hubSpotNonprofits"
            })
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.whenEligibleForNewPricing.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.whenEligibleForNewPricing.answer"
      })
    })]
  });
};